import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { FCCalendar } from '@algomusinc/domain';

@Injectable({ providedIn: 'root' })
export class ForecastLookupService {

  environment = EnvironmentService.environment;

  // Subjects

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */

  // Observables
  
  constructor(private http: HttpClient) {
  }


  GetAccountslist() {
    return this.http.get(`${this.environment.ForecastMapping}/GetAccountslist`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetRegionList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetRegionList`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetCountryList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetCountryList`)
      .pipe(map(response => {
        return response;
      }));
  }


  GetPromotionEventList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetPromotionEventList`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetPlanningMonthByStartDate(startDate: any) {
    return this.http.get(`${this.environment.ForecastMapping}/GetPlanningMonth?startdate=${startDate}`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetLookupItemsList() {
    return this.http.get(`${this.environment.MappingManager}/itemgetlist`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetFiscalYearList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetFiscalYearList`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetPlanningMonthList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetPlanningMonthList`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetPlanningWeekList(body: any = {}) {
    const query = Object.keys(body).map(key => {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.ForecastMapping}/GetPlanningWeekList?${query}`)
      .pipe(map(response => {
        return response;
      }));
  }

  GetForecastRetailerList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.ForecastMapping}/GetForecastRetailerList`,
      { params }
    );
  }

  GetSeasonalityList(): Observable<any> {
    return this.http.get<any>(
      `${this.environment.ForecastMapping}/GetSeasonalityList`,
    );
  }

  GetForecastWeekPeriodList(): Observable<any> {
    return this.http.get<any>(
      `${this.environment.ForecastMapping}/GetForecastWeekPeriodList`,
    );
  }

  GetItemsListByRetailer(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.ForecastMapping}/GetItemsListByRetailer`,
      params
    );
  }

  ForecastManagerMeasuresGetList(): Observable<any> {
    return this.http.get<FCCalendar[]>(
      `${this.environment.ForecastMapping}/forecastManagerMeasuresGetList`,
    );
  }


  GetProductHierarchyList(): Observable<any> {
    return this.http.get<any>(`${this.environment.ForecastManager}/getHierarchyMetadataList`,)
      .pipe(map(response => {
        return response;
      }));
  }

  UpdateProductHierarchyLIst(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ForecastManager}/insertHierarchyMetadataItem`, body)
      .pipe(map(response => {
        return response;
      }));
  }

}
